/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';
import type { Info } from './Info';
import {
    InfoFromJSON,
    InfoFromJSONTyped,
    InfoToJSON,
} from './Info';

/**
 * Types to be assigned to individual nodes, providing additional render info per node, potentially empty for single-entity hierarchies
 * @export
 * @interface EntityType
 */
export interface EntityType {
    /**
     * ID of the type, will be referenced in the EntityNode
     * @type {string}
     * @memberof EntityType
     */
    id: string;
    /**
     * Singular label of the entity, might be shown to the user when the tree is filtered down to a specific entity type
     * @type {string}
     * @memberof EntityType
     */
    label: string;
    /**
     * List of infos for all values of this entity type.
     * @type {Array<Info>}
     * @memberof EntityType
     */
    infos: Array<Info>;
    /**
     * By default true, might be false for entity nodes which are initially hidden and the user must click to expand and see
     * @type {boolean}
     * @memberof EntityType
     */
    initiallyVisible: boolean;
    /**
     * Color of each entity node with this type, in hex notation.
     * @type {string}
     * @memberof EntityType
     */
    color?: string;
    /**
     * 
     * @type {IconRef}
     * @memberof EntityType
     */
    icon?: IconRef;
}

/**
 * Check if a given object implements the EntityType interface.
 */
export function instanceOfEntityType(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "infos" in value;
    isInstance = isInstance && "initiallyVisible" in value;

    return isInstance;
}

export function EntityTypeFromJSON(json: any): EntityType {
    return EntityTypeFromJSONTyped(json, false);
}

export function EntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'infos': ((json['infos'] as Array<any>).map(InfoFromJSON)),
        'initiallyVisible': json['initiallyVisible'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
    };
}

export function EntityTypeToJSON(value?: EntityType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'infos': ((value.infos as Array<any>).map(InfoToJSON)),
        'initiallyVisible': value.initiallyVisible,
        'color': value.color,
        'icon': IconRefToJSON(value.icon),
    };
}

